import url from './url';



export default url(() => '/news/create');
